<template>
  <v-main>
    <v-container fluid :class="containerClass" :style="containerStyle">
      <router-view :key="$route.path" />
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'DefaultView',

  props: {
    patrolPanelVisible: {
      type: Boolean,
      default: false
    },
    rightPatrolPanelVisible: {
      type: Boolean,
      default: false
    },
    rightPanelWidth: {
      type: Number,
      default: 0
    }
  },

  computed: {
    containerClass() {
      const classes = []
      if (this.patrolPanelVisible) classes.push('with-patrol-panel')
      if (this.rightPatrolPanelVisible) classes.push('with-right-patrol-panel')
      return classes.join(' ')
    },
    containerStyle() {
      const styles = {
        transition: 'padding-top 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), padding-right 0.3s ease, margin-right 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)'
      }

      // Padding top for top patrol panel
      if (this.patrolPanelVisible) {
        const panelHeight = this.$vuetify.breakpoint.smAndDown ? 90 : 130
        styles.paddingTop = `${panelHeight}px`
      }

      // Margin right dla prawego panelu patroli - content robi miejsce
      if (this.rightPatrolPanelVisible) {
        styles.marginRight = `${this.rightPanelWidth}px`
      }

      return styles
    }
  }
}
</script>

<style scoped>
.with-patrol-panel {
  min-height: calc(100vh - 64px - 130px); /* Viewport - AppBar - PatrolPanel */
}

.with-patrol-panel.with-right-patrol-panel {
  /* Gdy oba panele są aktywne */
  min-height: calc(100vh - 64px - 130px);
}

@media (max-width: 600px) {
  .with-patrol-panel {
    min-height: calc(100vh - 56px - 90px); /* Viewport - AppBar(mobile) - PatrolPanel(mobile) */
  }
}

/* Na małych ekranach prawy panel nie powinien wpływać na layout */
@media (max-width: 1264px) {
  .with-right-patrol-panel {
    margin-right: 0 !important;
  }
}
</style>
